const getOrderLineHCPCSCode = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      return indexOrderLine['HCPC S Code']['HCPC S Code'] || indexOrderLine['HCPC S Code'];
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => item['HCPC S Code']['HCPC S Code'] || item['HCPC S Code']).join(', ')
    : null;
};

export default getOrderLineHCPCSCode;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineHCPCSCode.js